/**
 * TEMPORARY: Composable для переопределения тенанта в целях тестирования
 *
 * КАК ОТКАТИТЬСЯ К .env: Выберите "↻ Auto (from .env)" в TenantSwitcher
 * @see src/features/tenantSwitcher/TENANT_SWITCHER_README.md - полные инструкции по откату и удалению
 *
 * TODO: Удалить этот файл после завершения тестирования
 */

const TENANT_OVERRIDE_KEY = 'dev_tenant_override'

/**
 * Получить переопределенный тенант из localStorage
 */
export function getTenantOverride(): string | null {
  if (typeof window === 'undefined') {
    return null
  }

  return localStorage.getItem(TENANT_OVERRIDE_KEY)
}

/**
 * Установить переопределение тенанта в localStorage
 */
export function setTenantOverride(tenantId: string | null): void {
  if (typeof window === 'undefined') {
    return
  }

  if (tenantId) {
    localStorage.setItem(TENANT_OVERRIDE_KEY, tenantId)
  } else {
    localStorage.removeItem(TENANT_OVERRIDE_KEY)
  }
}

/**
 * Очистить переопределение тенанта
 */
export function clearTenantOverride(): void {
  setTenantOverride(null)
}

/**
 * TEMPORARY: Composable для управления переопределением тенанта
 */
export function useTenantOverride() {
  const overrideTenant = ref<string | null>(getTenantOverride())

  const setOverride = (tenantId: string | null) => {
    setTenantOverride(tenantId)
    overrideTenant.value = tenantId
    // Перезагружаем страницу для применения изменений темы
    window.location.reload()
  }

  const clearOverride = () => {
    clearTenantOverride()
    overrideTenant.value = null
    window.location.reload()
  }

  return {
    overrideTenant: readonly(overrideTenant),
    setOverride,
    clearOverride,
  }
}
